import React from 'react';
import { Button } from 'reactstrap';
import RenderRow from '../comoponents/RenderRow';
import { LANGUAGE, HomePageFields } from '../constant';
import { ObjectWrapper, SectionName, LanguageTitle, HomePageSectionInner } from '../styles';

export default function HomePage({
  handleUpload,
  handleFileRemove,
  handleOnChange,
  data,
  edit,
  handleUpdate,
}) {
  const FieldsObject = HomePageFields.map((e) => ({
    ...e,
    contentFields: LANGUAGE.reduce((acc, input) => {
      const languageTitle = input === 'En' ? 'English' : 'Traditional Chinese';
      return {
        ...acc,
        [languageTitle]: e.contentFields.map((c) => ({
          ...c,
          language: input,
          key: input === 'En' ? c.key : `${c.key}_zh`,
        })),
      };
    }, {}),
  }));

  return (
    <>
      {edit && (
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <SectionName>Home Page</SectionName>
          <Button size="sm" color="primary" onClick={handleUpdate}>
            Submit
          </Button>
        </div>
      )}
      {FieldsObject.map((section) => (
        <ObjectWrapper key={section.name}>
          <SectionName>{section.name}</SectionName>
          <HomePageSectionInner length={section.commonFields.length}>
            {section.commonFields.map((field) => (
              <RenderRow
                key={field.key}
                handleUpload={handleUpload}
                handleFileRemove={handleFileRemove}
                onChange={handleOnChange}
                field={field}
                data={data}
              />
            ))}

            {Object.entries(section.contentFields).map(([languageTitle, contentFields]) => (
              <ObjectWrapper
                key={languageTitle}
                style={{
                  padding: '20px 10px 10px 10px',
                }}
              >
                <LanguageTitle>{languageTitle}</LanguageTitle>

                {contentFields.map((field) => (
                  <RenderRow
                    key={field.key}
                    handleUpload={handleUpload}
                    handleFileRemove={handleFileRemove}
                    onChange={handleOnChange}
                    field={field}
                    data={data}
                  />
                ))}
              </ObjectWrapper>
            ))}
          </HomePageSectionInner>
        </ObjectWrapper>
      ))}
    </>
  );
}
